
/**
 * translations
 * stores translations, detects language, returns strings
 * @returns {{t: getTranslation}}
 */
const lang = () => {
    function getTranslation(str: string): string {
        if (window.mb.hasOwnProperty('translations') && window.mb.translations.hasOwnProperty(str)) {
            return window.mb.translations[str]
        }
        return str
    }

    return {
        t: getTranslation
    };
};

export default lang